var exports = {
  "Nr": "x234b8571--8ae6d7--card",
  "Qc": "x234b8571--8ae6d7--place-number",
  "EC": "x234b8571--8ae6d7--place-wrapper",
  "Kk": "x234b8571--8ae6d7--icon",
  "p0": "x234b8571--8ae6d7--medals",
  "C0": "x234b8571--8ae6d7--medal",
  "TM": "x234b8571--8ae6d7--medal-label",
  "bK": "x234b8571--8ae6d7--gold",
  "Ut": "x234b8571--8ae6d7--silver",
  "dy": "x234b8571--8ae6d7--bronze",
  "vt": "x234b8571--8ae6d7--description-icon",
  "rt": "x234b8571--8ae6d7--description-icon--inner",
};

module.exports = exports;
